import { useQuery } from "@tanstack/react-query";
import { api, type Api } from "@api/bot-base-api-request";
import {
  BotWalletSupportedChain,
  Wallet,
  WalletType,
} from "@/providers/wallet";
import { PositionsHistoryBotResponse } from "./types";

const POSITIONS_QUERY_KEY = "positions-history-bot";

const fetchPositionsHistory = async (
  api: Api,
  userId?: string,
  wallet?: Wallet
): Promise<PositionsHistoryBotResponse> => {
  return api
    .get("historicalPnl", {
      searchParams: {
        userId: userId ?? "",
        walletAddress: wallet?.address ?? "",
        chainId:
          wallet?.walletType === WalletType.ETH
            ? BotWalletSupportedChain.ETH
            : BotWalletSupportedChain.SOL,
      },
    })
    .json();
};

const useGetBotPositionsHistory = (userId?: string, wallet?: Wallet) => {
  return useQuery({
    queryKey: [POSITIONS_QUERY_KEY, userId, wallet?.address, wallet?.chain],
    queryFn: async () => fetchPositionsHistory(api, userId, wallet),
    enabled: !!userId && !!wallet,
  });
};

export { useGetBotPositionsHistory };
